<template>
  <div style="height: 100%;background-color: white">
    <el-row style="height: calc(100% - 100px)">
      <el-col :span="16" style="height: 100%">
        <div class="video-wrapper" style="border: 1px solid #DCDFE6;" id="remote">
          <h4>远程视频-{{userName}}</h4>
          <div id="remote-video"></div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="video-wrapper" style="height:200px;border: 1px solid #DCDFE6;">
          <h4>本地视频</h4>
          <div id="local-video"></div>
        </div>
      </el-col>
    </el-row>
    <div style="margin-top: 10px;text-align: center">
<!--          <el-button type="success" round @click="getStartToken">开始创建</el-button>-->
      <el-button :disabled="isNo" type="primary" @click="logoutRoomButton1"> &nbsp;挂 &nbsp;&nbsp;&nbsp;&nbsp; 断&nbsp; </el-button>
    </div>
  </div>
</template>

<script>
import { ZegoExpressEngine } from 'zego-express-engine-webrtc'
import axios from 'axios'
export default {
  name: 'zgPage',
  data () {
    return {
      AppID: 3654222617,
      server: 'wss://webliveroom3654222617-api-bak.imzego.com/ws',
      userID: '', // 用户id
      roomID: '', // 房间id zegodemoroom
      zg: null,
      localStreamID: '',
      localStream: null,
      remoteStream: null,
      remotestreamID: '',
      remoteStreamList: [],
      token: '',
      userName: '',
      isNo: true
    }
  },
  created () {},
  mounted () {},
  destroyed () {
    this.logoutRoomButton()
  },
  methods: {
    getDataMsg (obj) {
      this.userID = this.getuuid()
      this.AppID = obj.AppID
      this.server = obj.server
      this.roomID = obj.roomID
      // this.token = obj.token
      // this.getStartToken()
    },
    getStartToken () {
      let url = 'https://newjky.wecare-u.net/api/demo/zegotoken?userid='
      let vm = this
      axios.get(url + this.userID).then(res => {
        // console.log('Got token: ')
        vm.token = res.data.token
        vm.createZegoExpressEngine()
      })
    },
    // Create ZegoExpressEngine
    createZegoExpressEngine () {
      this.isNo = true
      if (this.roomID === '') {
        return
      }
      this.zg = new ZegoExpressEngine(this.AppID, this.server)
      this.zg.setDebugVerbose(false)
      this.joinRoom()
      // 房间状态更新回调
      // 此处在登录房间成功后，立即进行推流。在实现具体业务时，您可选择其他时机进行推流，只要保证当前房间连接状态是连接成功的即可。
      // 房间状态更新回调
      this.zg.on('roomStateChanged', async (roomID, reason, errorCode, extendedData) => {
        if (reason === 'LOGINED') {
          console.log('与房间连接成功，只有当房间状态是连接成功时，才能进行推流、拉流等操作。')
        }
      })

      this.zg.on('roomUserUpdate', (roomID, updateType, userList) => {
        // 其他用户进出房间的通知
      })

      let vm = this
      this.zg.on('roomStreamUpdate', async (roomID, updateType, streamList, extendedData) => {
        // 房间内其他用户音视频流变化的通知
        if (updateType === 'ADD') {
          streamList.forEach(function (stream) {
            if (stream.user.userName.indexOf('用户') !== -1) {
              console.log(999)
            } else {
              vm.startPlay(stream)
            }
          })
        } else if (updateType === 'DELETE') {
          // 流删除，通过流删除列表 streamList 中每个流的 streamID 进行停止拉流。
          streamList.forEach(function (stream) {
            // const streamID = stream.streamID
            // vm.zg.stopPlayingStream(streamID)
            // vm.zg.destroyStream(this.remoteStream)

            vm.zg.stopPublishingStream(this.remotestreamID)
            vm.zg.destroyStream(this.remoteStream)
            vm.zg.stopPlayingStream(this.remotestreamID)
            vm.remoteStream = null
            vm.remotestreamID = ''
          })
          vm.logoutRoomButton()
        }
      })
    },
    logoutRoomButton1 () {
      this.isNo = true
      this.$store.commit('set_is_mqtt', false)
      this.store2.dispatch('other/update_zg_info', '')
      this.$emit('zgEnd')// 自己挂断
      this.logoutRoomButton()
    },
    logoutRoomButton () {
      if (this.localStream) {
        this.zg.stopPublishingStream(this.remotestreamID)
        this.zg.destroyStream(this.remoteStream)
        this.zg.stopPlayingStream(this.remotestreamID)
        this.remoteStream = null
        this.remotestreamID = ''
        this.zg.stopPublishingStream(this.localStreamID)
        this.zg.destroyStream(this.localStream)
        this.zg.stopPlayingStream(this.localStreamID)
        this.localStreamID = ''
        this.localStream = null
        this.zg.logoutRoom(this.roomID)
        this.userName = ''
        this.zg = null
        this.isNo = true
        this.roomID = ''
        this.$store.commit('set_is_mqtt', false)
        this.store2.dispatch('other/update_zg_info', '')
      }
    },
    async startPlay (stream) {
      this.userName = stream.user.userName
      console.log(stream)
      // 流新增，开始拉流
      // 此处演示拉取流新增的列表中第一条流的音视频
      this.remotestreamID = stream.streamID
      // streamList 中有对应流的 streamID
      this.remoteStream = await this.zg.startPlayingStream(stream.streamID)
      // 创建媒体流播放组件
      const remoteView = this.zg.createRemoteStreamView(this.remoteStream)
      remoteView.play('remote-video', {enableAutoplayDialog: true})
    },
    async joinRoom () {
      this.isNo = false
      console.log(this.roomID)
      // userID 用户自己设置，必须保证全局唯一
      let userID = this.userID
      // userName 用户自己设置，没有唯一性要求
      let userName = '用户_' + userID
      // roomID 用户自己设置，必须保证全局唯一
      let roomID = this.roomID
      let vm = this
      // 登录房间，成功则返回 true
      // userUpdate 设置为 true 才能收到 roomUserUpdate 回调。
      this.zg.loginRoom(roomID, this.token, { userID, userName: userName }, { userUpdate: true }).then(async result => {
        if (result === true) {
          console.log('login success')
          // 与房间连接成功，只有当房间状态是连接成功时，才能进行推流、拉流等操作。
          // 创建流、预览
          // 调用 createStream 接口后，需要等待 ZEGO 服务器返回流媒体对象才能执行后续操作
          vm.localStream = await this.zg.createStream({
            camera: { videoQuality: 4, frameRate: 15, width: 320, height: 240, bitRate: 300, video: true }
          })
          // 创建媒体流播放组件
          const localView = vm.zg.createLocalStreamView(vm.localStream)
          localView.play('local-video', {enableAutoplayDialog: true})
          // 开始推流，将自己的音视频流推送到 ZEGO 音视频云，此处 streamID 由用户定义，需全局唯一
          vm.localStreamID = new Date().getTime().toString()
          vm.zg.startPublishingStream(vm.localStreamID, vm.localStream)
        }
      })
    },
    getuuid () {
      var s = []
      var hexDigits = '0123456789abcdef'
      for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
      }
      s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
      s[8] = s[13] = s[18] = s[23] = '-'
      return s.join('')
    }
  }
}
</script>

<style scoped>
h1,
h4 {
  padding-top: 8px;
  text-align: center;
}
.video-wrapper {
  /*width: 100%;*/
  height:  100%;
  /*margin: 0 auto;*/
  overflow-y: auto;
}

#remote-video, #local-video {
  width: 100%;
  height: calc(100% - 40px);
  /*display: inline-block;*/
  /*position: relative;*/
}
.video-wrapper video {
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/systemlog/childComponents/zgPage.vue